export const SET_PLAYER_ID = 'SET_PLAYER_ID';

export const setPlayerId = (playerId) => ({
    type: SET_PLAYER_ID, playerId
});
